<template>
    <page-side-bar-menu :menus="menus"></page-side-bar-menu>
</template>
<script>
import PageSideBarMenu from "@/components/PageSideBarMenu";

export default {
    name: "Sidebar",
    data() {
        return {
            menus: [
                { title: 'About', active: this.isActive(1), 'url': '/library/about' },
                { title: 'Digital Library', active: this.isActive(2), 'url': '/library/digital-library' },
                { title: 'Resources', active: this.isActive(3), 'url': '/library/resources' },
                { title: 'Services', active: this.isActive(4), 'url': '/library/services' },
                { title: 'Rules and Regulations', active: this.isActive(5), 'url': '/library/rules' },
                { title: 'Library Timings', active: this.isActive(6), 'url': '/library/timings' },
                { title: 'Committee', active: this.isActive(7), 'url': '/library/committee' },
                { title: 'Team', active: this.isActive(8), 'url': '/library/team' },
                { title: 'Infrastructure', active: this.isActive(9), 'url': '/library/infrastructure' },
                { title: 'Notices', active: this.isActive(10), 'url': '/library/notices' },
                { title: 'Downloads', active: this.isActive(11), 'url': '/library/downloads' },
                { title: 'Gallery', active: this.isActive(12), 'url': '/library/gallery' },
            ]
        }
    },
    props: {
        active: {
            default: 1,
            type: Number
        }
    },
    methods: {
        isActive(index) {
            return this.active === index;
        }
    },
    components: {
        PageSideBarMenu
    }
}
</script>
<style scoped>
</style>